// ¿Hay llave para cobrar con Stripe? (si no, el servicio se reserva sin pago en línea).
export const pagosDisponibles = () => Boolean(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
